import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

const PublicRoute = () => {
  const token = localStorage.getItem('token')
  const location = useLocation()

  const isAuthPage = ['/', '/forgot-password', '/login-otp', '/set-password'].includes(location.pathname)

  return token && isAuthPage ? <Navigate to="/app-users" /> : <Outlet />
}

export default PublicRoute
